import Constants from "../../params/constants";

interface TablePaginationProps {
  page: number;
  pageCount: number;
  total: number;
  pageSize: number;
  onGotoPage: (page: number) => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onSetPageSize: (size: number) => void;
}

export function TablePagination({
  page,
  pageCount,
  total,
  pageSize,
  onGotoPage,
  onPreviousPage,
  onNextPage,
  onSetPageSize,
}: TablePaginationProps) {
  const canPreviousPage = page > 0;
  const canNextPage = page < pageCount - 1;
  const pageOptions = Array.from({ length: pageCount }, (_, i) => i);

  return (
    <div className="jf-tablePagination">
      <div style={{ flexGrow: 1 }}>
        <ul className="jf-pagination">
          <li className="jf-paginate_button jf-page-item first">
            <button
              type="button"
              aria-label="First page"
              onClick={() => onGotoPage(0)}
              disabled={!canPreviousPage}
              className="page-link"
            >
              «
            </button>
          </li>
          <li className="jf-paginate_button jf-page-item previous">
            <button
              type="button"
              aria-label="Previous page"
              onClick={onPreviousPage}
              disabled={!canPreviousPage}
              className="page-link"
            >
              ‹
            </button>
          </li>
          {pageOptions[page - 1] !== undefined && (
            <li className="jf-paginate_button jf-page-item">
              <button
                type="button"
                aria-label={`Go to page ${page}`}
                onClick={() => onGotoPage(page - 1)}
                className="page-link"
              >
                {page}
              </button>
            </li>
          )}
          <li className="jf-paginate_button jf-page-item active">
            <button
              type="button"
              aria-current="page"
              aria-label={`Current page, page ${page + 1}`}
              className="page-link"
            >
              {page + 1}
            </button>
          </li>
          {pageOptions[page + 1] !== undefined && (
            <li className="jf-paginate_button jf-page-item">
              <button
                type="button"
                aria-label={`Go to page ${page + 2}`}
                onClick={() => onGotoPage(page + 1)}
                className="page-link"
              >
                {page + 2}
              </button>
            </li>
          )}
          <li className="jf-paginate_button jf-page-item next">
            <button
              type="button"
              aria-label="Next page"
              onClick={onNextPage}
              disabled={!canNextPage}
              className="page-link"
            >
              ›
            </button>
          </li>
          <li className="jf-paginate_button jf-page-item last">
            <button
              type="button"
              aria-label="Last page"
              onClick={() => onGotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className="page-link"
            >
              »
            </button>
          </li>
        </ul>
      </div>
      <div className="d-flex">
        <div className="jf-dataTables_length align-items-center">
          <label>
            <span className="jf-visually-hidden">Rows per page</span>
            <select
              aria-label="Rows per page"
              className="jf-custom-select jf-custom-select-sm jf-form-control jf-form-control-sm"
              value={pageSize}
              onChange={(e) => onSetPageSize(Number(e.target.value))}
            >
              {Constants.LimitOptions.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </label>
        </div>
        <span className="jf-dataTables_info">
          {total > 0
            ? `Showing ${pageSize * page + 1} – ${Math.min(
                pageSize * (page + 1),
                total,
              )} of ${total}`
            : "No records"}
        </span>
      </div>
    </div>
  );
}
